import React from 'react';
import { SearchResultContext } from '../../context/SearchResultContext';
import { PaginationButton } from './components/PaginationButton';
import Icon from '../../../icon';
import Select from '../../../select/Select';

const PaginationBlockDesktop = ({ onClickHandler }) => {
	const { results, page, setPage, itemsPerPage, setItemsPerPage } = React.useContext(SearchResultContext);

	const totalPages = Math.ceil(Number(results.totalItems) / itemsPerPage);
	const showPrevPageBtn = Number(page) > 1;
	const showNextPageBtn = Number(page) < totalPages;
	const ItemsPerPage = [12, 24, 48];

	const getPagesToDisplay = (page, totalPages) => {
		let start = Number(page) > 4 ? Number(page) - 1 : 3;
		if (totalPages - Number(page) < 3) start = totalPages - 4;
		return Array.from({ length: totalPages + 1 }, (x, i) => i).slice(
			start,
			start + 3
		);
	};

	const handleScroll = () => {
		const el = document.getElementById('search-result-page-client');
		setTimeout(() => {
			if (el) {
				// Try scrollIntoView first, with fallback to scrollTo
				el.scrollIntoView({ behavior: 'smooth', block: 'start' });
			} else {
				// Fallback to scroll to top if element not found
				window.scrollTo({ top: 0, behavior: 'smooth' });
			}
		}, 250);
	};

	const filteredPages =
		totalPages < 7
			? Array.from({ length: totalPages }, (x, i) => i)
			: getPagesToDisplay(Number(page), totalPages);

	// Filter items per page options based on totalItems
	const filteredItemsPerPage = ItemsPerPage.filter((option, index) => {
		const optionValue = Number(option);
		const totalItems = Number(results.totalItems);

		// Keep options smaller than totalItems
		if (optionValue < totalItems) return true;

		// Also keep the first option that is >= totalItems (to show all on one page)
		const isFirstLargerOption = ItemsPerPage.slice(0, index).every(prevOption => Number(prevOption) < totalItems);
		if (optionValue >= totalItems && isFirstLargerOption) return true;

		return false;
	});

	return (
		<div className='pagination-block'>
			{totalPages <= 0 || results.totalItems < 12 ? null
				: <div className='h-display-flex h-justify-content-end'>
					<Select label="Items per page:" options={filteredItemsPerPage.map(i => ({ value: i, label: i }))} value={itemsPerPage} onChange={(e) => {
						setItemsPerPage(Number(e.target.value));
						setPage('1');
					}} />
				</div>}
			{totalPages <= 1 ? null
				: <div className='pagination-block-wrapper'>
					{/* Previous page button */}
					{showPrevPageBtn && (
						<PaginationButton
							ariaLabel="Previous page"
							onclick={() => {
								handleScroll();
								setPage((Number(page) - 1).toString());
							}}
						>
							<div className='pagination-icon-wrapper'>
								<Icon icon="arrow-left" additionalClasses='pagination-icon' />
							</div>
						</PaginationButton>
					)}
					{/* First button, always '1' */}
					{totalPages > 7 ? (
						<>
							<PaginationButton
								activeButton={Number(page) === 1}
								onclick={() => {
									handleScroll();

									setPage('1');
								}}
							>
								<p className='pagination-button-label'>
									1
								</p>
							</PaginationButton>
							{/* Second button, always '2' or '...' */}
							<PaginationButton
								activeButton={Number(page) === 2}
								onclick={() => {
									handleScroll();

									Number(page) <= 4 && setPage('2');
								}}
								// disabled if used as truncate 'button'
								disabled={Number(page) > 4}
							>
								<p className='pagination-button-label'>
									{Number(page) <= 4 ? '2' : '...'}
								</p>
							</PaginationButton>

							{filteredPages.map((i) => {
								if (i > 1 && i < totalPages - 1)
									return (
										<PaginationButton
											activeButton={Number(page) === i}
											onclick={() => {
												handleScroll();
												setPage(i.toString());
											}}
											key={i}
										>
											<p className='pagination-button-label'>
												{i}
											</p>
										</PaginationButton>
									);
							})}
							{/* Second last button, always totalPages - 1 or '...' */}
							<PaginationButton
								activeButton={Number(page) === totalPages - 1}
								// disabled if used as truncate 'button'
								disabled={Number(page) <= totalPages - 4}
								onclick={() => {
									handleScroll();
									Number(page) > totalPages - 4 &&
										setPage((totalPages - 1).toString());
								}}
							>
								<p className='pagination-button-label'>
									{Number(page) > totalPages - 4 ? totalPages - 1 : '...'}
								</p>
							</PaginationButton>
							{/* Last button, always totalPages */}
							<PaginationButton
								activeButton={Number(page) === totalPages}
								onclick={() => {
									handleScroll();
									setPage(totalPages.toString());
								}}
							>
								<p className='pagination-button-label'>
									{totalPages}
								</p>
							</PaginationButton>
						</>
					) : (
						<>
							{Array.from({ length: totalPages }, (x, i) => i).map((i) => {
								return (
									<PaginationButton
										activeButton={Number(page) === i + 1}
										onclick={() => {
											handleScroll();
											setPage((i + 1).toString());
										}}
										key={i}
									>
										<p className='pagination-button-label'>
											{i + 1}
										</p>
									</PaginationButton>
								);
							})}
						</>
					)}
					{/* Next page button */}
					{showNextPageBtn && (
						<PaginationButton
							ariaLabel="Next page"
							onclick={() => {
								handleScroll();
								setPage((Number(page) + 1).toString());
							}}
						>
							<div className='pagination-icon-wrapper'>
								<Icon icon="arrow-right" additionalClasses='pagination-icon' />
							</div>
						</PaginationButton>
					)}
				</div >
			}
		</div >
	);
};

export { PaginationBlockDesktop };
